$(document).ready(function(){

  $.get( $("#form-search-out-stock").data('action'), function( data ) {
    data = $(data);
    $("#form-search-out-stock").html(data.find(".wrapper-form"));
    $("#form-search-out-stock").find('.btn-form').removeAttr('onclick');
  });

  $("body").on("submit", "#form-search-out-stock form", function(e){
    var $form = $("#form-search-out-stock form");
    $form.find('.btn-form').prop('disabled', true);
    $.ajax({
           type: "POST",
           url: $form.attr("action"),
           data: $form.serialize(), // serializes the form's elements.
           success: function(data)
           {
               data = $(data);

               $("#form-search-out-stock").html(data.find(".wrapper-form"));
               $("#form-search-out-stock").find('.btn-form').removeAttr('onclick');
               $form.find('.btn-form').prop('disabled', false);
           }
         });

    e.preventDefault();
    return false;
  });
});